import React, { FC } from 'react';

type Size = 'small' | 'medium' | 'large' | 'extraLarge';
interface TextProps{
    data?: string;
    size?: Size;
    isBold?: boolean;
}
export const Text: FC<TextProps> = ({ data, size, isBold }) => {
  const getsize = (fontSize: Size): string => {
    switch (fontSize) {
      case 'small':
        return '16px';
      case 'medium':
        return '18px';
      case 'large':
        return '20px';
      case 'extraLarge':
        return '34px';
      default:
        return '16px';
    }
  };

  if (!data) {
    return (
      <p className={`font-${isBold ? 'bold' : 'normal'}] line-height-170 text-red-500`}>No translation detected</p>
    );
  }
  return (
    <p
      className={`font-${isBold ? 'bold' : 'normal'}] line-height-170`}
      style={{ fontSize: getsize(size || 'medium') }}
    >
      {data}
    </p>
  );
};
